<template>
  <div class="UploadInfo">
    <div class="mainTitle">{{$t('verificationStatus.poaVerification.poaInformation.infoTip.tip3')}}</div>
    <div class="tip">• {{$t('verificationStatus.poaVerification.poaInformation.infoTip.tip1')}}</div>
    <div class="tip">• {{$t('verificationStatus.poaVerification.poaInformation.infoTip.tip2')}}</div>
  </div>
</template>
<script>
export default {
    name:"UploadInfo"
}
</script>
<style lang="scss" scoped>
.UploadInfo {
    .mainTitle {
        font-weight: 700;
        font-size: 12px;
        line-height: 16.8px;
    }
    .tip{
        color:rgba(50, 50, 50, 1);
        font-weight: 400;
        font-size: 12px;
        margin-left: 12px;
        line-height: 16.8px;
    }
}
</style>